<template>
  <v-layout column>
    <v-navigation-drawer v-model="rightSpecial" fixed right light width="400">
      <v-flex class="pl-2 pt-1" style="height: 100vh" v-if="loading">
        <v-icon @click.stop="closeDialog">close</v-icon>
        <v-layout align-center justify-center row fill-height>
          <v-progress-circular
            indeterminate
            color="#c0c0c0"
          ></v-progress-circular>
        </v-layout>
      </v-flex>
      <v-flex class="pl-2 pt-1" v-if="!loading && error !== ''">
        <div class="error">{{ error }}</div>
      </v-flex>
      <v-flex class="pl-2 pt-1" v-if="!loading && debt_billing">
        <v-icon @click.stop="closeDialog">close</v-icon>
        <v-list-tile>
          <v-flex sm12 md12 xs12>
            <v-subheader v-if="debt_billing">{{
              debt_billing.user?.name || ""
            }}</v-subheader>
          </v-flex>
        </v-list-tile>
        <v-divider />
        <v-list-tile style="height: 50px">
          <v-flex sm12 md6 xs6>
            <v-subheader v-if="debt_billing">
              <a
                :href="
                  debt_billing.transaction
                    ? 'https://beta.dashboard.pagar.me/#/transactions/' +
                      debt_billing.transaction.id
                    : ''
                "
                target="_blank"
              >
                {{
                  debt_billing.transaction
                    ? "#" + debt_billing.transaction.id
                    : ""
                }}
              </a>
            </v-subheader>
          </v-flex>
          <v-flex sm12 md6 xs6>
            <div
              style="
                display: flex;
                align-items: center;
                justify-content: center;
                height: 30px;
              "
              :class="`detail-status detail-status--${
                this.status === 'Atrasada' ? 'atrasada' : debt_billing.status
              }`"
            >
              {{ status }}
            </div>
          </v-flex>
        </v-list-tile>
        <v-card
          color="blue-grey darken-2"
          class="text-xs-center white--text pl-2 pr-2 pt-3 pb-3 mb-2"
        >
          {{ formatReason(debt_billing) }}
        </v-card>
      </v-flex>
      <v-list-tile avatar v-if="debt_billing">
        <v-list-tile-action>
          <v-icon class="grey--text">tag</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-sub-title>ID</v-list-tile-sub-title>
          <v-list-tile-title>
            <div>{{ debt_billing.id }}</div>
          </v-list-tile-title>
        </v-list-tile-content>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              flat
              icon
              color="grey darken-1"
              v-on="on"
              @click.prevent="copyBillingId(debt_billing.id)"
            >
              <v-icon> file_copy </v-icon>
            </v-btn>
          </template>
          <span>Copiar id da fatura.</span>
        </v-tooltip>
      </v-list-tile>

      <v-list-tile avatar>
        <v-list-tile-action>
          <v-icon class="grey--text">date_range</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-sub-title>Criado em</v-list-tile-sub-title>
          <v-list-tile-title>
            <div>{{ debt_billing.created_at | formatDateTime }}</div>
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <v-list-tile avatar>
        <v-list-tile-action>
          <v-icon class="grey--text">edit_calendar</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-sub-title v-if="debt_billing"
            >Atualizado em</v-list-tile-sub-title
          >
          <v-list-tile-title>
            <div>{{ debt_billing.updated_at | formatDateTime }}</div>
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <v-list-tile avatar>
        <v-list-tile-action>
          <v-icon class="grey--text">event_note</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-sub-title>Vencimento</v-list-tile-sub-title>
          <v-list-tile-title>
            <div>{{ debt_billing.due_date | formatBoletoExp }}</div>
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <v-list-tile
        avatar
        class="v-list-item"
        v-if="debt_billing.status === 'paid'"
      >
        <v-list-tile-action>
          <v-icon class="green--text">event_available</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-sub-title>Pago em</v-list-tile-sub-title>
          <v-list-tile-title>
            {{
              (debt_billing.transaction?.paid_at ||
                debt_billing.paid_at ||
                debt_billing.informed_payment_date ||
                debt_billing.transaction?.date_updated) | formatBoletoExp
            }}
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <v-list-tile
        avatar
        class="v-list-item"
        v-if="debt_billing.status === 'paid'"
      >
        <v-list-tile-action>
          <v-icon class="green--text">local_atm</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-sub-title>Valor Pago</v-list-tile-sub-title>
          <v-list-tile-title
            v-if="
              debt_billing.total &&
              debt_billing.transaction &&
              Number(debt_billing.total.toFixed(2)) ===
                Number(debt_billing.transaction.amount || 0)
            "
            >R$
            {{ (debt_billing.transaction.paid_amount || 0) | formatCurrency }}
          </v-list-tile-title>
          <v-list-tile-title v-else>
            R$
            {{
              (debt_billing.transaction?.paid_amount
                ? (debt_billing.transaction?.paid_amount || 0) / 100
                : debt_billing.total || 0) | formatCurrency
            }}
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-divider pb-3 />

      <!--Ações-->
      <div pt-5 class="text-xs-center">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              v-if="debt_billing.invoice_url"
              v-on="on"
              fab
              color="blue"
              :href="debt_billing.invoice_url"
              target="_blank"
              class="round"
            >
              <v-icon large>receipt</v-icon>
            </v-btn>
          </template>
          <span>Demonstrativo</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              fab
              dark
              color="indigo"
              v-on="on"
              v-if="
                debt_billing.transaction &&
                (debt_billing.transaction.payment_method === 'boleto' ||
                  debt_billing.payment_service === 'boletosimples') &&
                debt_billing.status !== 'paid'
              "
              :href="
                debt_billing.transaction.payment_method === 'boleto'
                  ? debt_billing.transaction.boleto_url
                  : debt_billing.transaction.url
              "
              target="_blank"
              class="round"
            >
              <v-icon large dark> mdi-barcode</v-icon>
            </v-btn>
          </template>
          <span>Abrir o boleto do membro.</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              v-if="debt_billing.reason !== 'canceled_by_juntos'"
              fab
              color="orange"
              v-on="on"
              class="round"
              @click="openDueDateCalendar(debt_billing)"
            >
              <v-icon large>gavel</v-icon>
            </v-btn>
          </template>
          <span>Alterar data de vencimento</span>
        </v-tooltip>
      </div>

      <v-divider />
      <v-list-tile avatar class="v-list-item">
        <v-list-tile-action>
          <v-icon class="green--text">notifications_active</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title class="font-weight-bold"
            >Comunicados</v-list-tile-title
          >
        </v-list-tile-content>
      </v-list-tile>
      <communication-billing
        v-if="debt_billing.id"
        :billing_id="debt_billing.id"
      />
    </v-navigation-drawer>

    <v-dialog v-model="calendarDialog" max-width="600">
      <v-card class="calendar-card">
        <v-card-title class="headline">Alterar Data de Vencimento</v-card-title>
        <v-card-text class="calendar-container">
          <v-menu
            v-model="openCalendar"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="newDueDate"
                label="Nova data de Vencimento"
                prepend-icon="event"
                readonly
                v-on="on"
              />
            </template>
            <v-date-picker
              dark
              v-model="newDueDate"
              :min="actualDueDate"
              :max="maxDate"
              :allowed-dates="allowedDates"
              @input="openCalendar = false"
            />
          </v-menu>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" text @click="calendarDialog = false"
            >Cancelar</v-btn
          >
          <v-btn color="green" text @click="changeDueDate">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snackbar.value"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :top="snackbar.top"
      :bottom="snackbar.bottom"
    >
      {{ snackbar.message }}
    </v-snackbar>
  </v-layout>
</template>

<script>
import firestore from "../../firebase/firestore";
import moment from "moment";
import dayjs from "dayjs";
import { updateSpecialBilling } from "../../services/billing";
import { hasPermissionMixin } from "../../mixin/permissionsMixin";
import { calendarMixin } from "../../mixin/calendarMixin";
import { mapState } from "vuex";
import CommunicationBilling from "../../components/faturaDetails/CommunicationBilling.vue";

export default {
  name: "DetalhesFaturaEspecial",

  components: { CommunicationBilling },
  mixins: [calendarMixin, hasPermissionMixin],
  props: {
    rightSpecial: {
      type: Boolean,
      required: true,
    },
    debtBillingID: {
      type: String,
      required: true,
    },
  },

  data: () => ({
    loading: false,
    error: "",
    debt_billing: {},
    debt_billing_id: "",
    snackbar: {
      timeout: 6000,
      value: false,
      message: "",
      color: "",
      top: false,
      bottom: false,
      mode: "",
    },
    calendarDialog: false,
    actualId: null,
    actualDueDate: null,
    hasChangedDueDate: false,
    openCalendar: false,
    newDueDate: null,
  }),

  async created() {
    let vm = this;
    vm.loading = true;
    const date = new Date();
    date.setDate(date.getDate() + 5);
    this.due_date = date.toISOString().substring(0, 10);
  },

  watch: {
    async debtBillingID() {
      if (this.debtBillingID.length > 0) {
        try {
          const debtBillingRef = firestore
            .collection("debt_billing")
            .doc(this.debtBillingID);
          let res = await debtBillingRef.get();

          if (!res.exists || !res.data()?.customer_id) {
            const billingRef = firestore
              .collection("billing")
              .doc(this.debtBillingID);
            res = await billingRef.get();

            if (!res.exists || !res.data()?.customer_id) {
              console.error("Erro ao pegar os dados de billing");
              this.loading = false;
              return;
            }
          }

          const userDoc = await firestore
            .collection("users")
            .doc(res.data().customer_id)
            .get();
          const userData = userDoc.data();

          const debt_billing = {
            ...res.data(),
            id: res.id,
            user: userData,
            conta: "",
          };

          this.debt_billing = debt_billing;
        } catch (error) {
          console.error("Erro ao pegar os dados:", error);
        } finally {
          this.loading = false;
        }
      }
    },
  },

  methods: {
    async changeDueDate() {
      const permission = await this.hasPermission(
        "change_special_billing_due_date",
      );

      if (!permission) {
        this.calendarDialog = false;
        this.showSnackBar(
          "Usuário sem permissão para realizar essa ação",
          "top",
          "red",
        );
        return;
      }

      if (this.hasChangedDueDate) {
        this.calendarDialog = false;
        this.showSnackBar(
          "Data de vencimento já foi alterada uma vez",
          "top",
          "red",
        );
        return;
      }
      const data = {
        due_date: this.newDueDate,
        has_changed_due_date: true,
        status: "reprocessing",
        change_due_date_agent: {
          id: this.user.id,
          name: this.user.name,
          email: this.user.email,
        },
      };
      updateSpecialBilling(this.actualId, data);
      this.calendarDialog = false;
      this.showSnackBar(
        "Data de vencimento alterada com sucesso!",
        "top",
        "green",
      );
    },

    closeDialog() {
      this.$emit("closeDialog");
      this.debt_billing = {};
    },

    formatReason(billingReason) {
      if (!billingReason || typeof billingReason !== "object") {
        return "other";
      }

      if (billingReason.deal) return "Campanhas/Acordos";
      if (billingReason.fine) return "Multa de cancelamento";
      if (billingReason.joined_billings) return "Junção de Faturas";
      if (billingReason.cancellation_charge) return "Fatura de débitos";
      if (billingReason.is_cancel_billing) return "Fatura de Encerramento";

      return "Outros";
    },

    copyBillingId(id) {
      navigator.clipboard.writeText(id);
      this.showSnackBar("Copiado para área de transferência", "top", "green");
    },

    showSnackBar(msg, direction, color) {
      this.snackbar.message = msg;
      this.snackbar.top = direction === "top";
      this.snackbar.bottom = direction === "bottom";
      this.snackbar.color = color;
      this.snackbar.value = true;
    },

    openDueDateCalendar(specialBilling) {
      this.actualId = specialBilling.id;
      this.hasChangedDueDate = specialBilling.has_changed_due_date;
      this.actualDueDate = dayjs(specialBilling.due_date).toISOString();
      this.calendarDialog = true;
    },
  },

  filters: {
    formatDateTime(value) {
      if (!value || value === "") return "";
      if (typeof value === "string") return moment(value).format("DD/MM/YYYY");
      else return moment(value.toDate()).format("DD/MM/YYYY HH:mm");
    },

    formatBoletoExp(value) {
      if (!value || value === "") return "";
      if (typeof value === "string") {
        return moment(new Date(value)).utcOffset(3).format("DD/MM/YYYY");
      } else {
        return moment(value.toDate()).format("DD/MM/YYYY");
      }
    },
  },

  computed: {
    ...mapState(["user"]),

    maxDate() {
      if (!this.actualDueDate) return dayjs().toISOString();
      return dayjs(this.actualDueDate).add(60, "day").toISOString();
    },

    status: function () {
      let tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() - 1);

      if (this.debt_billing.status === "") return "xxx";
      else if (this.debt_billing.status === "error") return "Erro";
      else if (
        this.debt_billing.status === "paid" ||
        this.debt_billing.status === "succeeded"
      )
        return "Paga";
      else if (this.debt_billing.status === "pending") return "Processar";
      else if (this.debt_billing.status === "refused") return "Recusada";
      else if (this.debt_billing.status === "reprocessing")
        return "Reprocessando";
      else if (this.debt_billing.status === "pending_approval")
        return "Em Análise";
      else if (this.debt_billing.status === "generating") return "Gerando";
      else if (this.debt_billing.status === "opened") return "Aberto";
      else if (this.debt_billing.status === "canceled") return "Expirado";
      else if (this.debt_billing.status === "overdue") return "Atrasada";
      else if (this.debt_billing.status === "generation_failed")
        return "Falha ao gerar";
      else if (this.debt_billing.status === "validation_failed")
        return "Inválido";
      else if (this.debt_billing.status === "free") return "Abonado";
      else if (this.debt_billing.status === "in_queue") return "Programado";
      else if (this.debt_billing.status === "refunded") return "Reembolsado";
      else if (this.debt_billing.status === "negotiated") return "Negociado";
      else if (this.debt_billing.status === "parceled") return "Parcelado";
      else if (this.debt_billing.status === "waiting_payment") return "Aberta";
      else if (this.debt_billing.status === "free_pending")
        return "Pend. p/ Abono";
      else if (this.debt_billing.status === "postponed") return "Adiada";
      else return this.debt_billing.status;
    },
  },
};
</script>

<style scoped lang="scss">
.detail-status {
  height: 50px;
  color: #fff;
  // font-size: 15px;
  border-radius: 3px;
  font-weight: 600;
  text-align: center;
  padding: 0px 10px;

  &--paid {
    background-color: #3cb880;
  }

  &--succeeded {
    background-color: #3cb880;
  }

  &--free {
    background-color: #3cb880;
  }

  &--refused {
    background-color: orange;
    color: #fff;
  }

  &--canceled {
    background-color: black;
    color: #fff;
  }

  &--pending {
    background-color: #888;
  }

  &--waiting_payment {
    background-color: #888;
  }

  &--overdue {
    background-color: red;
  }

  &--opened {
    background-color: #888;
  }

  &--reprocessing {
    background-color: #333;
    color: #fff;
  }

  &--atrasada {
    background-color: red;
    color: #fff;
  }

  &--overdue {
    background-color: red;
    color: #fff;
  }

  &--generation_failed {
    background-color: red;
    color: #fff;
  }

  &--validation_failed {
    background-color: red;
    color: #fff;
  }

  &--overdue {
    background-color: red;
    color: #fff;
  }

  &--in_queue {
    background: blue;
    color: #fff;
  }

  &--refunded {
    background-color: #3cb880;
  }

  &--negotiated {
    background-color: grey;
  }

  &--parceled {
    background-color: grey;
  }

  &--error {
    background: red;
    color: #fff;
  }

  &--pending_approval {
    background-color: #888;
  }

  &--free_pending {
    background-color: #888;
  }

  &--postponed {
    background-color: #ffd700;
    color: #fff;
  }
}

.v-btn.round {
  // padding-top: 50px;
  border-radius: 50%;
  height: 48px;
  // max-width: 28px;
  width: 48px;
  padding: 0%;
}

.sub-title {
  color: #999;
  font-size: 0.8rem;
}

.v-list__tile__sub-title {
  color: #999;
  font-size: 0.8rem;
}
</style>
